import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkle, Lock } from '@phosphor-icons/react';

export const UpgradePrompt = ({ type = 'post-generation', tier, onDismiss }) => {
  if (tier === 'scale') return null;

  if (type === 'post-generation' && tier !== 'starter') return null;

  const configs = {
    'post-generation': {
      text: 'Want deeper, more strategic content?',
      cta: 'Upgrade to Pro',
      link: '/dashboard/billing',
      style: 'bg-zinc-800/40 border border-white/5',
    },
    'media-locked': {
      text: tier === 'starter'
        ? 'Unlock premium media creation — videos, characters, carousels, and voiceovers.'
        : 'Continue creating by getting more credits.',
      cta: tier === 'starter' ? 'Upgrade & Get Credits' : 'Get Credits',
      link: '/dashboard/billing',
      style: 'bg-amber-500/5 border border-amber-500/20',
    },
    'scale-upsell': {
      text: "You're growing fast — scale your results with more credits and advanced features.",
      cta: 'Upgrade to Scale',
      link: '/dashboard/billing',
      style: 'bg-emerald-500/5 border border-emerald-500/20',
    },
    'dashboard': {
      text: tier === 'starter'
        ? 'Unlock videos, AI characters, carousels, voiceovers, and more.'
        : 'Get more monthly credits and priority AI.',
      cta: tier === 'starter' ? 'Upgrade to Pro' : 'Upgrade to Scale',
      link: '/dashboard/billing',
      style: 'bg-gradient-to-r from-amber-500/5 to-transparent border border-amber-500/15',
    },
  };

  const config = configs[type] || configs['post-generation'];

  return (
    <div data-testid={`upgrade-prompt-${type}`} className={`rounded-xl p-4 ${config.style}`}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          {type === 'media-locked' ? (
            <Lock size={16} className="text-amber-400 shrink-0" />
          ) : (
            <Sparkle size={16} weight="fill" className="text-amber-400 shrink-0" />
          )}
          <p className="text-sm text-zinc-300">{config.text}</p>
        </div>
        <Link
          to={config.link}
          className="text-xs font-medium bg-white/10 hover:bg-white/15 text-white px-3 py-1.5 rounded-full transition-colors flex items-center gap-1 shrink-0"
        >
          {config.cta}
          <ArrowRight size={12} />
        </Link>
      </div>
      {onDismiss && (
        <button onClick={onDismiss} className="text-[10px] text-zinc-600 hover:text-zinc-400 mt-1">
          Dismiss
        </button>
      )}
    </div>
  );
};

export default UpgradePrompt;
